import { render, staticRenderFns } from "./alarmVideos.vue?vue&type=template&id=164da19a&"
import script from "./alarmVideos.vue?vue&type=script&lang=js&"
export * from "./alarmVideos.vue?vue&type=script&lang=js&"
import style0 from "./alarmVideos.vue?vue&type=style&index=0&id=164da19a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports